import React from 'react';

const OptionsListItemContainer = () => {
	return (
		<li className="vtex-login-2-x-optionsListItem optionsListItem vtex-login-2-x-optionsListItemContainer optionsListItemContainer mb3"></li>
	);
};

export default OptionsListItemContainer;
